export enum QuestionnaireType {
  FULL1003 = 'FULL1003',
  NTL = 'NTL', // No-Talk Lock flow
}
